export default "__VITE_ASSET__DwwgIvtA__"